import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _Exportations, _ImportCostSettlement, _SupplierPaymentOrder, _SupplierPaymentOrderItem, _TotalControlNationalizationCustomBondedWarehouse } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const TCN001 = ({ configProcedure }: Props) => {

    const totalcontroN = useDataBean(_TotalControlNationalizationCustomBondedWarehouse);
    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(totalcontroN.bean.Observations)
        }

        if (configProcedure?._pushProps) {
            let x = {
                Item: totalcontroN.bean.Item,
                GuideNumber: totalcontroN.bean.GuideNumber,
                Bulks: totalcontroN.bean.Bulks,
                Weight: totalcontroN.bean.Weight,
                Transportator: totalcontroN.bean.Transportator,
                ShippingFormNumber: totalcontroN.bean.ShippingFormNumber,
                ReceptionFormNumber: totalcontroN.bean.ReceptionFormNumber,
                ManifestNumber: totalcontroN.bean.ManifestNumber,
                ManifestDate: totalcontroN.bean.ManifestDate,
                EntryDateDEPAD: totalcontroN.bean.EntryDateDEPAD,
                Inventoried: totalcontroN.bean.Inventoried,
                InventoryDate: totalcontroN.bean.InventoryDate,
                InventoryNumber: totalcontroN.bean.InventoryNumber,
                SigningInventoryDateDEPAD: totalcontroN.bean.SigningInventoryDateDEPAD,
                Nationalized: totalcontroN.bean.Nationalized,
                Subheading: totalcontroN.bean.Subheading,
                AcceptanceNumber: totalcontroN.bean.AcceptanceNumber,
                AcceptanceDate: totalcontroN.bean.AcceptanceDate,
                LicenceNumber: totalcontroN.bean.LicenceNumber,
                DeclarationNumber: totalcontroN.bean.DeclarationNumber,
                MerchandiseReleaseNumber: totalcontroN.bean.MerchandiseReleaseNumber,
                MerchandiseReleaseDate: totalcontroN.bean.MerchandiseReleaseDate,
                Project: totalcontroN.bean.Project,
                RecordTaken: totalcontroN.bean.RecordTaken,
                RecordNumber: totalcontroN.bean.RecordNumber,
                RecordMadeDate: totalcontroN.bean.RecordMadeDate,
                Destination: totalcontroN.bean.Destination,
                FOBValueUSD: totalcontroN.bean.FOBValueUSD,
                CIFValueUSD: totalcontroN.bean.CIFValueUSD,
                ValueCOP: totalcontroN.bean.ValueCOP,
                Delivered: totalcontroN.bean.Delivered,
                DeliveryDate: totalcontroN.bean.DeliveryDate,
                Elements: totalcontroN.bean.Elements,
                Observations: totalcontroN.bean.Observations,
                State: 1,
                Since: _single.getCurrenDate(),
                IDEmployee: _single.getAccountID()

            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(totalcontroN.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        totalcontroN.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItem()
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        totalcontroN.update().then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">
            <div className="col-md-12">


                <div className="row">
                    <div className="col-md-6">
                        <label>Artículo</label>
                        <input type="text" name="Item" className="form-control" value={totalcontroN.bean.Item} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Numero de Guía</label>
                        <input type="text" name="GuideNumber" className="form-control" value={totalcontroN.bean.GuideNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Graneles</label>
                        <input type="text" name="Bulks" className="form-control" value={totalcontroN.bean.Bulks} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Peso</label>
                        <input type="text" name="Weight" className="form-control" value={totalcontroN.bean.Weight} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Transportador</label>
                        <input type="text" name="Transportator" className="form-control" value={totalcontroN.bean.Transportator} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de formulario de envío</label>
                        <input type="text" name="ShippingFormNumber" className="form-control" value={totalcontroN.bean.ShippingFormNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de formulario de recepción</label>
                        <input type="text" name="ReceptionFormNumber" className="form-control" value={totalcontroN.bean.ReceptionFormNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de manifiesto</label>
                        <input type="text" name="ManifestNumber" className="form-control" value={totalcontroN.bean.ManifestNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="ManifestDate" label="Fecha Manifiesto" value={totalcontroN.bean.ManifestDate} setDate={(e: any) => { totalcontroN.setBean({ ...totalcontroN.bean, "ManifestDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="EntryDateDEPAD" label="Fecha de entrada DEPAD" value={totalcontroN.bean.EntryDateDEPAD} setDate={(e: any) => { totalcontroN.setBean({ ...totalcontroN.bean, "EntryDateDEPAD": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <BasicSwitch label="Inventariado" estado={totalcontroN.bean.Inventoried} eventChange={(e) => { totalcontroN.setBean({ ...totalcontroN.bean, "Inventoried": e }) }}></BasicSwitch>
                    </div>
                    <div className="col-md-6">
                        <InputDate name="InventoryDate" label="Fecha de inventario" value={totalcontroN.bean.InventoryDate} setDate={(e: any) => { totalcontroN.setBean({ ...totalcontroN.bean, "InventoryDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de inventario</label>
                        <input type="text" name="InventoryNumber" className="form-control" value={totalcontroN.bean.InventoryNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="SigningInventoryDateDEPAD" label="Fecha de inventario de firma DEPAD" value={totalcontroN.bean.SigningInventoryDateDEPAD} setDate={(e: any) => { totalcontroN.setBean({ ...totalcontroN.bean, "SigningInventoryDateDEPAD": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <BasicSwitch label="Nacionalizado ?" estado={totalcontroN.bean.Nationalized} eventChange={(e) => { totalcontroN.setBean({ ...totalcontroN.bean, "Nationalized": e }) }}></BasicSwitch>
                    </div>
                    <div className="col-md-6">
                        <label>Subtítulo</label>
                        <input type="text" name="Subheading" className="form-control" value={totalcontroN.bean.Subheading} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de aceptación</label>
                        <input type="text" name="AcceptanceNumber" className="form-control" value={totalcontroN.bean.AcceptanceNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="AcceptanceDate" label="Fecha de Aceptación" value={totalcontroN.bean.AcceptanceDate} setDate={(e: any) => { totalcontroN.setBean({ ...totalcontroN.bean, "AcceptanceDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de licencia</label>
                        <input type="text" name="LicenceNumber" className="form-control" value={totalcontroN.bean.LicenceNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de declaración</label>
                        <input type="text" name="DeclarationNumber" className="form-control" value={totalcontroN.bean.DeclarationNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de lanzamiento de mercancía</label>
                        <input type="text" name="MerchandiseReleaseNumber" className="form-control" value={totalcontroN.bean.MerchandiseReleaseNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="MerchandiseReleaseDate" label="Fecha de lanzamiento de la mercancía" value={totalcontroN.bean.MerchandiseReleaseDate} setDate={(e: any) => { totalcontroN.setBean({ ...totalcontroN.bean, "MerchandiseReleaseDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Proyecto</label>
                        <input type="text" name="Project" className="form-control" value={totalcontroN.bean.Project} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Registro tomado</label>
                        <input type="text" name="RecordTaken" className="form-control" value={totalcontroN.bean.RecordTaken} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de registro</label>
                        <input type="text" name="RecordNumber" className="form-control" value={totalcontroN.bean.RecordNumber} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="RecordMadeDate" label="Fecha de grabación" value={totalcontroN.bean.RecordMadeDate} setDate={(e: any) => { totalcontroN.setBean({ ...totalcontroN.bean, "RecordMadeDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Destino</label>
                        <input type="text" name="Destination" className="form-control" value={totalcontroN.bean.Destination} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Valor FOBUSD</label>
                        <input type="text" name="FOBValueUSD" className="form-control" value={totalcontroN.bean.FOBValueUSD} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Valor CIF en USD</label>
                        <input type="text" name="CIFValueUSD" className="form-control" value={totalcontroN.bean.CIFValueUSD} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>ValorCOP</label>
                        <input type="text" name="ValueCOP" className="form-control" value={totalcontroN.bean.ValueCOP} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <BasicSwitch label="Entregado ?" estado={totalcontroN.bean.Delivered} eventChange={(e) => { totalcontroN.setBean({ ...totalcontroN.bean, "Delivered": e }) }}></BasicSwitch>
                    </div>
                    <div className="col-md-6">
                        <InputDate name="DeliveryDate" label="Fecha de entrega" value={totalcontroN.bean.DeliveryDate} setDate={(e: any) => { totalcontroN.setBean({ ...totalcontroN.bean, "DeliveryDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Elementos</label>
                        <input type="text" name="Elements" className="form-control" value={totalcontroN.bean.Elements} onChange={totalcontroN.handleChange} />
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>

                        <textarea name="Observations" className="form-control" value={totalcontroN.bean.Observations} onChange={(e) => { totalcontroN.setBean({ ...totalcontroN.bean, 'Observations': e.target.value }) }} />
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={create}>Guardar Datos*</BasicButton>
                    </div>
                </div>
            </div>
        </div>
    )
}